import { Container } from "react-bootstrap";

const ContainerWrapper = ({ children }) => {
  return <Container>{children}</Container>;
};
export default ContainerWrapper;
